import type {MediaPlayer} from 'amazon-ivs-player';

export interface PlayerContext {
  position: number;
}

export class AmazonIVSPlayerContext implements PlayerContext {
  constructor(private player: MediaPlayer) {}

  get position(): number {
    return this.player.getPosition();
  }
}
